var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_1813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.691406 15.3169C0.691406 16.0233 1.23326 16.4877 2.15246 16.4877H6.23568C6.3131 18.3552 7.77415 19.9904 9.81576 19.9904C11.8671 19.9904 13.3281 18.3649 13.4055 16.4877H17.4887C18.3983 16.4877 18.9498 16.0233 18.9498 15.3169C18.9498 14.3493 17.9628 13.4785 17.1307 12.6174C16.4922 11.9497 16.318 10.5757 16.2406 9.46301C16.1728 5.65071 15.1859 3.19304 12.612 2.26416C12.2831 0.996616 11.2478 0 9.81576 0C8.39341 0 7.34841 0.996616 7.0291 2.26416C4.45533 3.19304 3.46838 5.65071 3.40066 9.46301C3.32325 10.5757 3.14908 11.9497 2.51047 12.6174C1.66867 13.4785 0.691406 14.3493 0.691406 15.3169ZM2.56853 15.0266V14.9105C2.74269 14.6299 3.32325 14.0591 3.82639 13.4978C4.52306 12.7238 4.85204 11.4756 4.93912 9.58879C5.01652 5.36044 6.27439 4.01549 7.92897 3.56072C8.17086 3.50267 8.30633 3.38656 8.316 3.13498C8.34503 2.1287 8.92558 1.42236 9.81576 1.42236C10.7156 1.42236 11.2865 2.1287 11.3252 3.13498C11.3349 3.38656 11.4606 3.50267 11.7026 3.56072C13.3668 4.01549 14.6247 5.36044 14.7021 9.58879C14.7892 11.4756 15.1181 12.7238 15.8051 13.4978C16.318 14.0591 16.8889 14.6299 17.063 14.9105V15.0266H2.56853ZM7.74512 16.4877H11.8961C11.8187 17.8037 10.9865 18.626 9.81576 18.626C8.65466 18.626 7.81286 17.8037 7.74512 16.4877Z",
    fill: "#EA6C52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_1813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/AlertIcon.64031ac391a2d5b770d8f071592af690.svg";
export { ForwardRef as ReactComponent };